import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Modal, Row, Col, Card } from 'react-bootstrap';
import Headers from '../../components/Headers/Headers';
import Page from '../../components/Page/Page';
import Reload from '../../components/reload/reload';
import SearchBar from '../../components/SearchBar/SearchBar';
import ApiMServer from '../../services/ApiMServer';
import { NotifyModal } from '../../components/NotifyModal/NotifyModal';
import ModernTable from '../../components/ModernTable/ModernTable';

import dateFormat from 'dateformat';
import decodeJwt from '../../hooks/decode';

const UnitsMembers = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [unit, setUnit] = useState({});
  const [show, setShow] = useState(false);
  const [member, setMember] = useState({});
  const [members, setMembers] = useState([]);
  const [allMembers, setAllMembers] = useState([]);
  const [error, setError] = useState('');
  const [valor, setValor] = useState('');
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem('user'));
  
  const userDecoded = decodeJwt();
  const { permissionSGU } = userDecoded;
  if (permissionSGU?.units?.read !== true) {
    navigate("/home");
  }

  const getPermissions = (member) => {
    if (user?.permissionSGU?.units?.write === false) {
      return true;
    } else {
      if (!member.managerId) {
        return false;
      } else if (member._id === user?._id) {
        return true;
      } else if (member.managerId !== id) {
        return true;
      } else {
        return false;
      }
    }
  }

  const handleShow = () => setShow(true);

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleClose = () => {
    setShow(false);
    handleClean();
  };

  const handleClean = () => {
    setMember({});
    setValor('');
    setError('');
  };

  const [showModal, setShowModal] = useState(false);
  const [showModalCheckbox, setShowModalCheckbox] = useState(false);

  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isManager, setIsManager] = useState(null);

  const handleShowModal = (email) => {
    if (email === user.email) {
      return;
    }
    setSelectedEmail(email);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEmail(null);
  };

  const handleShowModalCheckbox = (email, isManager) => {
    setSelectedEmail(email);
    setIsManager(isManager)
    setShowModalCheckbox(true);
  };

  const handleCloseModalCheckbox = () => {
    setShowModalCheckbox(false);
    setSelectedEmail(null);
    setIsManager(null);
  };

  useEffect(() => {
    handleCompanyDetail();
  }, [id]);

  const handleCompanyDetail = async () => {
    try {
      const { data } = await ApiMServer.post('/company/detail', { id });
      setUnit(data);
      if (data?.members?.length) {
        const usersResponse = await ApiMServer.post('/usersfilter', { filter: data.members });
        const orderedMembers = usersResponse.data.sort((a, b) => a.name.localeCompare(b.name));
        setMembers(orderedMembers);
        setAllMembers(orderedMembers);
      } else {
        setMembers([]);
        setAllMembers([]);
      }
    } catch (e) {
      handleAlertModalError("Erro ao carregar os membros!");
    } finally {
      setLoading(false);
    }
  };

  const handleEmailExclude = async (email) => {
    try {
      await ApiMServer.put('/emailexclude', { email: email, companyId: id });
      handleCompanyDetail();
      handleCloseModal();
      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      handleAlertModalError("Erro ao excluir email:", error);
    }
  };

  const toggleManagerStatus = useCallback(async (email, isManager) => {
    setLoading(true);
    try {
      if (!isManager) {
        await ApiMServer.post('/company/addgestor', { emails: email, id });
      } else {
        await ApiMServer.post('/company/rmgestor', { emails: email, id });
      }
      handleCloseModalCheckbox();
      handleCompanyDetail();
    } catch (error) {
      handleAlertModalError("Erro ao atualizar o status do usuário!");
    } finally {
      setLoading(false);
    }
  }, [id, handleCompanyDetail]);

  const handleEmail = async () => {
    if (!valor) {
      alert("O e-mail não pode ser vazio.");
      return;
    }
    try {
      const { data } = await ApiMServer.get('/email', { headers: { email: valor } });
      if (data?.email) {
        setMember(data);
        setError("");
      } else {
        setError("E-mail não encontrado.");
      }
    } catch (error) {
      setError("E-mail não encontrado.");
      setMember({});
    }
  };

  const handleEmailPut = async () => {
    try {
      await ApiMServer.put('/emailupdate', { ...member, companyId: id });
      handleCompanyDetail();
      handleClose();
      handleAlertModalSuccess('Atualizado com sucesso!');

    } catch (error) {
      console.error("Erro ao adicionar email:", error);
    }
  };

  const handleSearchData = (value) => {
    const filtered = allMembers.filter(item =>
      item?.name.toUpperCase().includes(value.toUpperCase()) ||
      item?.email.toUpperCase().includes(value.toUpperCase())
    );
    setMembers(filtered);
  };

  const totalPages = useMemo(() => Math.ceil(members.length / rowsPerPage), [members.length, rowsPerPage]);

  const paginatedMembers = useMemo(() => {
    const start = page * rowsPerPage;
    return members.slice(start, start + rowsPerPage);
  }, [members, page, rowsPerPage]);

  const handleChangePage = (newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleEmail();
    }
  };

  const columns = ["NOME", "E-MAIL", "FONE", "ÚLTIMA ATUALIZAÇÃO", "GESTOR", "AÇÃO"];

  // Função para renderizar checkbox do gestor
  const renderGestorCheckbox = (member) => (
    <Form.Check
      isValid
      type='checkbox'
      id={`manager-toggle-${member.email}`}
      label={!member.managerId ? "Usuário" : member.managerId === id ? "Gestor desta Unidade" : member.managerId !== id ? "Gestor de outra Unidade" : "Usuário"}
      checked={member.managerId === id}
      onChange={() => handleShowModalCheckbox(member.email, member.managerId === id)}
      disabled={getPermissions(member)}
    />
  );

  // Função para renderizar botões de ação
  const renderActions = (member) => (
    <div className="d-flex justify-content-center gap-2">
      <Button
        size="sm"
        style={{ width: "100px" }}
        variant='success'
        onClick={() => navigate(`/units/membros-editar/${member._id}`)}
        disabled={getPermissions(member)}
      >
        Editar
      </Button>
      <Button
        size="sm"
        style={{ width: "100px" }}
        variant='outline-danger'
        onClick={() => handleShowModal(member.email)}
        disabled={!user?.permissionSGU?.units?.read}
      >
        Remover
      </Button>
    </div>
  );

  // Configuração da paginação
  const getPaginationRange = useCallback(() => {
    const start = Math.max(page - 2, 0);
    const end = Math.min(page + 2, totalPages - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }, [page, totalPages]);

  const paginationConfig = {
    currentPage: page,
    totalPages: totalPages,
    rowsPerPage: rowsPerPage,
    total: members.length,
    currentStart: page * rowsPerPage,
    currentEnd: (page + 1) * rowsPerPage,
    pageNumbers: getPaginationRange(),
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  };

  return (
    <Page title={"Membros"}>
      <Headers page="Membros" />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Buscar usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label className="alert alert-warning">
            Usuários que não são do mesmo domínio de E-mail serão excluídos automaticamente no primeiro dia de cada mês!
          </Form.Label>
          <Form.Group controlId="emailInput">
            <Form.Label>E-mail</Form.Label>
            <Form.Control
              type="email"
              placeholder="email@example.com"
              value={valor}
              onChange={(e) => setValor(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <small style={{ color: "orange" }}>E-mail deve ter cadastro no aplicativo MOTOMCO ou site SGU!</small>
          </Form.Group>
          {member.email && <p>Nome: <strong>{member.name || "--"}</strong> </p>}
          {error && <p className="text-danger">{error}</p>}
          <Row className="mt-3">
            <Col>
              <Button
                onClick={handleEmail}
                variant="success"
                disabled={!valor.length}
              >
                Buscar usuário
              </Button>
            </Col>
            <Col className="text-end">
              {member.email && <Button onClick={handleEmailPut} variant="success">Adicionar</Button>}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Row className="g-2">
        <Col xs={12} sm={6} md={6} lg={3} xl={2} xxl={2}>
          <SearchBar onSearch={handleSearchData} />
        </Col>
        <Col xs={12} sm={6} md={6} lg={3} xl={2} xxl={2}>
          <Button
            variant="success"
            onClick={handleShow}
            className="w-100"
            disabled={!user?.permissionSGU?.units?.write}
          >
            Cadastrar usuário
          </Button>
        </Col>
      </Row>

      <Card className='mt-2'>
        <Card.Header>{unit.name || "--"}</Card.Header>
        <Card.Body className="p-0">
          <ModernTable 
            columns={columns}
            data={paginatedMembers.map((member) => ([
              member.name || " -- ",
              member.email || " -- ",
              member.fone || " -- ",
              member.updatedAt ? dateFormat(member.updatedAt, "dd/mm/yyyy HH:MM:ss") : " -- ",
              renderGestorCheckbox(member),
              '' // Placeholder para ações
            ]))}
            actions={(member, index) => renderActions(paginatedMembers[index])}
            pagination={paginationConfig}
          />
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja excluir o usuário com email: <strong>{selectedEmail}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={() => handleEmailExclude(selectedEmail)}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalCheckbox} onHide={handleCloseModalCheckbox} centered>
        <Modal.Header closeButton>
          <Modal.Title>Gestor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Confirmar ação para E-mail: <strong>{selectedEmail}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalCheckbox}>
            Cancelar
          </Button>
          <Button variant="success" onClick={() => toggleManagerStatus(selectedEmail, isManager)}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Page>
  );
};

export default UnitsMembers;
